import { render, staticRenderFns } from "./HotGameSection.vue?vue&type=template&id=417a1f8f"
import script from "./HotGameSection.vue?vue&type=script&lang=js"
export * from "./HotGameSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports